import { infiniteQueryOptions } from '@tanstack/react-query';

import { RQ_USER_RECOMMENDATIONS_FEED } from '../ReactQuery/cacheKeys';

import { fetchUserRecommendationsFeed } from './api';

export function userRecommendationsFeedInfiniteQueryOptions({
  limit,
  include_like_count,
  enabled,
  userId,
}: {
  limit: number;
  include_like_count: boolean;
  enabled?: boolean;
  userId?: number;
}) {
  return infiniteQueryOptions({
    queryKey: [RQ_USER_RECOMMENDATIONS_FEED, { userId, include_like_count }],
    enabled,
    queryFn: ({ pageParam }) =>
      fetchUserRecommendationsFeed({
        limit: String(limit),
        include_like_count: String(include_like_count),
        after: pageParam,
      }),
    initialPageParam: '',
    getNextPageParam: (lastPage) => {
      const { last, has_more } = lastPage.data.page_info ?? {};
      return has_more && last ? last : undefined;
    },
  });
}
